import { useEffect, useState } from "react";
import { fetchPublicBranding, PublicBranding } from "../api/publicBrandingApi";

const DEFAULT_PRIMARY = "#0B1D3A";
const DEFAULT_ACCENT = "#10B981";

export function usePublicBranding(subdomain?: string) {
  const [branding, setBranding] = useState<PublicBranding | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!subdomain) {
      setBranding(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    void fetchPublicBranding(subdomain).then((b) => {
      if (!cancelled) {
        setBranding(b);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [subdomain]);

  useEffect(() => {
    const primary = branding?.primaryColor?.trim() || DEFAULT_PRIMARY;
    const accent = branding?.accentColor?.trim() || DEFAULT_ACCENT;
    document.documentElement.style.setProperty("--portal-primary", primary);
    document.documentElement.style.setProperty("--portal-accent", accent);
    return () => {
      document.documentElement.style.removeProperty("--portal-primary");
      document.documentElement.style.removeProperty("--portal-accent");
    };
  }, [branding?.primaryColor, branding?.accentColor]);

  useEffect(() => {
    const href = branding?.faviconUrl?.trim();
    if (!href) {
      return;
    }
    let link = document.querySelector<HTMLLinkElement>("link[data-portal-favicon='1']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      link.setAttribute("data-portal-favicon", "1");
      document.head.appendChild(link);
    }
    link.href = href;
  }, [branding?.faviconUrl]);

  return { branding, loading };
}
